import { Globals } from './../../../globals';
import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
import { TakeawayServices } from '../services';
import { AngularFirestore } from 'angularfire2/firestore';
import { ConfigurationServices } from '../../configuration/services';


/**
 * Pantalla para crear un nuevo plato o update de uno existente
 * En el params recibimos si es un plato existente o uno nuevo. En caso de ser
 * UPDATE tenenmos que rellenar los campos del formulario
 */

@Component({
  selector: 'page-takeaway-delivery-favorites',
  templateUrl: 'takeaway-delivery-favorites.html',
})
export class TakeawayDeliveryFavoritesPage {



  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public takeawayServices: TakeawayServices,
    public globals: Globals,
    public afs: AngularFirestore,
    public configurationServices: ConfigurationServices
  ) {
    this.takeawayServices.getDeliveriesFavorites();
  }


  addDeliveriesFavorites(delivery) {
    this.afs.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries_favorites').add({
      'name': delivery.name,
    }).then(doc => {
      delivery.favorites_UID = doc.id;
    });
  }

  deleteDeliveriesFavorites(delivery) {
    this.afs.collection('restaurants/' + this.globals.restaurant_uid + '/deliveries_favorites').doc(delivery.favorites_UID).delete();
    delivery.favorites_UID = undefined;
  }


  getDeliveryImage(_delivery) {
    if (_delivery != undefined) {
      const delivery = this.takeawayServices.deliveries.find(t => t.name == _delivery);
      if (delivery != undefined) {
        return delivery.img;
      }
    }
  }

  changeDelivery(_delivery) {
    _delivery.active = !_delivery.active;
  }

  save() {
    this.takeawayServices.deliveries.forEach(delivery => {
      if (delivery.active && delivery.favorites_UID == undefined) {
        //insert
        this.addDeliveriesFavorites(delivery);
      }
      if (!delivery.active && delivery.favorites_UID != undefined) {
        //delete
        this.deleteDeliveriesFavorites(delivery);
      }
    });
    this.navCtrl.pop();
  }




}


// WEBPACK FOOTER //
// ./src/pages/takeaway/takeaway-delivery-favorites/takeaway-delivery-favorites.ts